// src/pages/RE/REG910F3.jsx 무작위 부여군 생성 - 출력

import React, {useEffect, useState} from 'react';
import {postData} from "utils/TransactionUtil";
import styleCom from "../RE/REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";

import ExcelJS from "exceljs";
import {saveAs} from "file-saver";


const REG910F3 = ({handle_Close,  comHandleClick_Save, paramHsptCd, paramRandId, paramRandGrp}) => {


    const [rows_randList, setRows_randList] = useState([]);
    const cols_randList = [
        { key: 'hsptNm',   name: '기관명',  width: '17%'},
        { key: 'randIdNm', name: '성명',  width: '10%' },
        { key: 'randGrp',  name: '랜덤그룹',    width: '8%'},
        { key: 'randSno', name: '순번',    width: '5%'},
        { key: 'randIndex', name: '구분값',    width: '5%'},
        { key: 'randIndexNm', name: '구분',    width: '15%'},
        { key: 'mapId', name: '환자 등록번호',    width: '15%'},
        { key: 'subjectName', name: '이름',    width: '10%'},
        { key: 'enrollmentDate', name: '(선택)등록일자',    width: '15%'},
    ];


    useEffect(() => {
        const param = {randId:paramRandId, hsptCd:paramHsptCd, randGrp:paramRandGrp};
        getRandomGenExcel(param);

    }, []);

    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭

        comHandleClick_Save(() => {
            exportToExcel(cols_randList, rows_randList, "random_list");
        });
    }, [comHandleClick_Save]);


    /* Call Service====================================================================================================*/

    async function getRandomGenExcel(param){

        //상세데이터 조회
        const res = await postData("/REW/getRandomContent", param);
        setRows_randList(res);
    }


    /* 엑셀 ************************************************************************ */
    const exportToExcel = async (columns, rows, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        // 헤더 추가
        worksheet.addRow(columns.map(col => col.name));

        // 데이터 추가
        rows.forEach(row => {
            const rowData = columns.map(col => row[col.key] ?? "");
            worksheet.addRow(rowData);
        });

        const totalRows = rows.length + 1; // 헤더 포함
        const totalCols = columns.length;

        // 컬럼 인덱스 찾기
        const hdColor1Index = columns.findIndex(col => col.key === "randIndex");
        const hdColor2Index = columns.findIndex(col => col.key === "randIndexNm");
        const hdColor3Index = columns.findIndex(col => col.key === "mapId");

        for (let r = 1; r <= totalRows; r++) {
            const row = worksheet.getRow(r);
            for (let c = 1; c <= totalCols; c++) {
                const cell = row.getCell(c);
                if (cell.value === undefined || cell.value === null) {
                    cell.value = "";
                }

                // 테두리 적용
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };

                if (r === 1) {
                    cell.font = {bold: true}; // 헤더 글씨 굵게
                }

                // hd_color_1: 헤더만 노란색
                if (r === 1 && c - 1 === hdColor1Index) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF00" } // 노란색
                    };
                }
                if (r === 1 && c - 1 === hdColor3Index) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF00" } // 노란색
                    };
                }


                // hd_color_2: 헤더 + 내용 모두 노란색
                if (c - 1 === hdColor2Index) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF00" } // 노란색
                    };
                }
            }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, `${fileName}.xlsx`);
    };
    /* ************************************************************************ */

    return(
        <main>

            <div className={styleCom.main_wrap}>
                <div style={{width: "100%", height:"600px"}}>
                    <DataGrid
                        cols={cols_randList}
                        rows={rows_randList}
                        rowHeight={37}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>

            </div>

        </main>
    )
}
export default REG910F3;